import {useLanguageContext, useThemeContext} from '../../../../../context';
import {Dropdown, MessageModal} from '../../../../common';
import TableBody from '../../../../common/TableContainer/TableBody';
import {firstLetterCaptilize} from '../../../../../constants';
import {useNavigate} from 'react-router-dom';
import {useState} from 'react';

const List = ({location, userPermission}) => {
    let navigate = useNavigate();

    const {I18n} = useLanguageContext();
    const {theme} = useThemeContext();

    const [archiveModal, setArchiveModal] = useState(false);

    const toggleArchiveModal = () => setArchiveModal(x => !x);

    const handleArchive = async location => {
        setArchiveModal(false);
    };

    const handleAction = async type => {
        switch (type) {
            case 'delete':
                let deleted = await location.archiveCustomer();
                break;
            case 'edit':
                navigate(`${location.id}/edit`);
                break;
        }
    };

    // commenting archive, need to cater conditions for archived locations
    const tableAction = [
        {
            title: I18n.edit,
            action: () => handleAction('edit'),
        },
        // {
        //     title: I18n[location.archive ? 'unarchive' : 'archive'],
        //     action: toggleArchiveModal,
        // },
    ];

    const navigateToNextScreen = () => {
        if (!userPermission?.canCrud) return;
        navigate(`${location.id}/edit`);
    };

    return (
        <>
            <TableBody className={`sixColumn cursorPointer`} onClick={navigateToNextScreen} style={{borderColor: theme.inputBorder}}>
                <div className="checkboxCol">
                    <p className="marBot0 fontSize14 OneLineTruncate" style={{color: theme.white}}>
                        {firstLetterCaptilize(location.location_name)}
                    </p>
                </div>
                <div className="BoxWidth justifyCenter">
                    <p className="fontSize14 OneLineTruncate" style={{color: theme.white}}>
                        {location.type || '-'}
                    </p>
                </div>
                <div className="BoxWidth justifyCenter">
                    <p className="fontSize14 OneLineTruncate" style={{color: theme.white}}>
                        {location.city || '-'}
                    </p>
                </div>
                <div className="BoxWidth justifyCenter">
                    <p className="fontSize14 OneLineTruncate" style={{color: theme.white}}>
                        {location.email || '-'}
                    </p>
                </div>
                <div className="BoxWidth justifyCenter">
                    <p className="fontSize14 OneLineTruncate" style={{color: theme.white}}>
                        {location.phone || '-'}
                    </p>
                </div>

                {userPermission?.canCrud && (
                    <div
                        className="BoxWidth justifyCenter"
                        onClick={e => {
                            e.stopPropagation();
                        }}>
                        <div className="listActionBox">
                            <Dropdown
                                dropDown={{
                                    name: 'threeDotIcon',
                                    fill: theme.barclaysBlue,
                                    width: 18,
                                    height: 4,
                                    viewBox: '0 0 18 4',
                                    option: tableAction,
                                }}
                            />
                        </div>
                    </div>
                )}
            </TableBody>

            <MessageModal
                setToggle={setArchiveModal}
                toggle={archiveModal}
                className="messageModal"
                description={location.archive ? 'Do you really want to unarchive this location' : 'Do you really want to archive this location'}
                secondaryCta={{
                    title: I18n.cancel,
                    action: toggleArchiveModal,
                }}
                primaryCta={{
                    title: I18n[location.archive ? 'unarchive' : 'archive'],
                    action: () => {
                        handleArchive(location);
                    },
                }}
            />
        </>
    );
};

export default List;
